import yup from "../../extensions/yup/methods/phone";
import { ContactMethodType, Title } from "../../modules/entities/Entities";
import { maxPhoneNumberLength } from "../../utils/PhoneUtils";

export const CustomerContactPageFormSchema = yup.object({
  name: yup.string().label('Name').required(),
  surname: yup.string().label('Surname').required(),
  email: yup
    .string()
    .label('Email')
    .test('email-mask-or-valid', 'Email is required', (value) => {
      if (!value) return false;
      if (value.includes('*')) return true;
      return yup.string().email().isValidSync(value);
    })
    .required(),
  phoneNumber: yup.string().label('Mobile').max(maxPhoneNumberLength).required(),
  preferredContactMethodType: yup.mixed<ContactMethodType>().required(),
  title: yup.mixed<Title>().required(),
  privacyStatementConfirmed: yup.boolean().label('Privacy statement').required().isTrue(),
});
